import { writable } from 'svelte/store';

export const isMonthOpen = writable(false);
export const isYearOpen = writable(false);
export const isSideBarOpen = writable(false);
